import React from 'react';
import { Box, Container, Stack, Text, Flex, Link, Icon, HStack, useColorModeValue, Button } from '@chakra-ui/react';
import { Github, Linkedin, FileText } from 'lucide-react';
export function Footer() {
  const bgColor = useColorModeValue('gray.800', 'gray.900');
  const borderColor = useColorModeValue('gray.700', 'gray.800');
  return <Box bg={bgColor} color="white" width="100%" data-id="element-153">
      <Container maxW="1200px" py={10} data-id="element-154">
        <Flex direction={{
        base: 'column',
        md: 'row'
      }} justify="space-between" align={{
        base: 'center',
        md: 'center'
      }} textAlign={{
        base: 'center',
        md: 'left'
      }} data-id="element-155">
          <Text fontSize="sm" mb={{
          base: 4,
          md: 0
        }} data-id="element-156">
            © {new Date().getFullYear()} Built with love by George Klenam
            Quarshie. All rights reserved.
          </Text>
          <HStack spacing={4} data-id="element-157">
            <Link href="https://github.com/georgeklenam" isExternal rounded="full" w={10} h={10} display="inline-flex" alignItems="center" justifyContent="center" transition="background 0.3s ease" bg="whiteAlpha.200" _hover={{
            bg: 'whiteAlpha.300'
          }} data-id="element-158">
              <Icon as={Github} boxSize={5} data-id="element-159" />
            </Link>
            <Link href="https://linkedin.com/in/georgeklenam" isExternal rounded="full" w={10} h={10} display="inline-flex" alignItems="center" justifyContent="center" transition="background 0.3s ease" bg="whiteAlpha.200" _hover={{
            bg: 'whiteAlpha.300'
          }} data-id="element-160">
              <Icon as={Linkedin} boxSize={5} data-id="element-161" />
            </Link>
            <Button as="a" href="#" size="sm" leftIcon={<FileText size={16} data-id="element-163" />} colorScheme="blue" data-id="element-162">
              Resume
            </Button>
          </HStack>
        </Flex>
      </Container>
      <Box borderTopWidth={1} borderStyle="solid" borderColor={borderColor} data-id="element-164">
        <Container as={Flex} maxW="1200px" py={4} direction={{
        base: 'column',
        md: 'row'
      }} justify={{
        base: 'center',
        md: 'center'
      }} align={{
        base: 'center',
        md: 'center'
      }} data-id="element-165">
          <Text fontSize="sm" textAlign="center" data-id="element-166">
            Using technology to make education and business more accessible
            across Africa
          </Text>
        </Container>
      </Box>
    </Box>;
}